export default "__VITE_ASSET__CBNKPh5p__"